import {type SVGProps, forwardRef} from 'react';

export const MicNoiseReductionIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            d='M19 11.5459C19.5523 11.5459 20 11.9728 20 12.5C20 16.3942 16.9463 19.6074 13 20.0771V22.0459C12.9997 22.5729 12.5521 23 12 23C11.4479 23 11.0003 22.5729 11 22.0459V20.0771C9.60725 19.9114 8.32539 19.4041 7.25 18.6455V16C8.34733 17.355 10.0671 18.2275 12 18.2275C15.3137 18.2275 18 15.6631 18 12.5C18 11.9728 18.4477 11.5459 19 11.5459Z'
            fill='currentColor'
        />
        <path
            d='M5 5C5.51768 5 5.94379 5.39333 5.99512 5.89746L6 6V20C6 20.5523 5.55228 21 5 21C4.44772 21 4 20.5523 4 20V6L4.00488 5.89746C4.05621 5.39333 4.48232 5 5 5Z'
            fill='currentColor'
        />
        <path
            d='M2 9C2.51768 9 2.94379 9.39333 2.99512 9.89746L3 10V17C3 17.5523 2.55228 18 2 18C1.44772 18 1 17.5523 1 17V10L1.00488 9.89746C1.05621 9.39333 1.48232 9 2 9Z'
            fill='currentColor'
        />
        <path
            fillRule='evenodd' clipRule='evenodd'
            d='M12 2C14.7613 2 16.9998 4.13668 17 6.77246V12.5C17 15.1359 14.7614 17.2725 12 17.2725C9.23858 17.2725 7 15.1359 7 12.5V6.77246C7.00015 4.13668 9.23867 2 12 2ZM12 3.90918C10.3432 3.90918 9.00015 5.19104 9 6.77246V12.5C9 14.0815 10.3431 15.3633 12 15.3633C13.6569 15.3633 15 14.0815 15 12.5V6.77246C14.9998 5.19104 13.6568 3.90918 12 3.90918Z'
            fill='currentColor'
        />
    </svg>
));
